// import { getThemeColor } from 'reactPath/utils/index';
// import { isDarkBlackPageTheme, canUseAfloatTheme } from 'reactPath/utils/check';
const Color = {
    white: '255,255,255,1',
    black: '0,0,0,1',
    transparent: '0,0,0,0',
    blue: '12,185,226,1',
    /**
   * 开放平台应用主主题色
   *
   * */
    openBlue: '89,135,251,1',
    royalBlue: '59,144,244,1',
    darkGold: '41,41,41,1',
    green: '52,187,192,1',
    lightBlack: '28,28,28,1',
    darkBlack: '18,18,18,1',
    light: '238,238,238,1',
    yellow: '255,166,74,1',
    boykeepYellow: '251,211,15,1',
    black35: '35,35,35,1',
};

export const Visibility = {
    visible: '1',
    hidden: '0',
};
const BackButtonType = {
    arrow: '0',
    text: '1',
    menu: '2',
};

const ThemeType = {
    common: '0',
    fullScreen: '1',
    afloat: '2',
};
const StatusBarStyleType = {
    black: '0',
    white: '1',
};

const TitleBarTheme = {
    StatusBarStyleType,
    Color,
    Visibility,
    BackButtonType,
    ThemeType,
    /*
    theme: "0" ,//"0"：默认样式，有标题栏,webview非全屏；"1"：无标题栏，webview全屏 ;"2"：有标题栏，webview全屏，标题栏悬浮在Webview上方；

    backgroundColor: '255,255,255,1', //titleBar背景色，需要将电量、信号栏设置相同颜色，rgba(0-255,0-255,0-255,0-1)

    backButtonColor: '255,255,255,1', //返回按钮颜色 rgba(0-255,0-255,0-255,0-1)

    backButtonType:"0"，          //返回按钮类型 0代表返回箭头，1文字按钮，2代表菜单

    backButtonText:"取消"， //当backButtonType = 1时可用

    backButtonVisible:"0", //是否显示返回按钮 0:隐藏；1：显示

    titleColor: '255,255,255,1', //标题颜色

    rightButtonText: "网络检测", //右侧按钮文字

    rightButtonColor: "255,255,255,1", //右侧按钮颜色 rgba(0-255,0-255,0-255,0-1)

    rightButtonVisible: "0", //是否显示右侧按钮 0:隐藏；1：显示

    rightButtonImageURL: ‘https://domain/a.jpg’  //图片网络地址，如果有设置图片， app支持版本：protocolVersion >= 16
    */
    ThemeCommon() {
        return {
            themeName: 'ThemeCommon',
            theme: ThemeType.common,
            // backgroundColor: isDarkBlackPageTheme() ? Color.lightBlack : Color.white,
            // titleColor: isDarkBlackPageTheme() ? Color.light : Color.black,
            backButtonType: BackButtonType.arrow,
            backButtonVisible: Visibility.visible,
            // backButtonColor: isDarkBlackPageTheme() ? Color.light : Color.black,
            // statusBarStyle: isDarkBlackPageTheme()
            //     ? StatusBarStyleType.white
            //     : StatusBarStyleType.black,
        };
    },
    ThemeFullScreen() {
        return {
            themeName: 'ThemeFullScreen',
            theme: ThemeType.fullScreen,
        };
    },
    //IOS上使用ThemeType.afloat需要protocol >= 16 (历史版本存在问题)
    ThemeAfloatDeviceAdd() {
        // if (!canUseAfloatTheme) {
        //     return this.ThemeAddDevice();
        // }
        return {
            themeName: 'ThemeAfloatDeviceAdd',
            theme: ThemeType.afloat,
            titleColor: Color.light,
            backgroundColor: Color.transparent,
            backButtonType: BackButtonType.arrow,
            backButtonVisible: Visibility.visible,
            backButtonColor: Color.light,
            // statusBarStyle: isDarkBlackPageTheme()
            //     ? StatusBarStyleType.white
            //     : StatusBarStyleType.black,
        };
    },

    //添加设备 暗黑模式标题不一样
    ThemeAddDevice() {
        return {
            themeName: 'ThemeAddDevice',
            theme: ThemeType.common,
            // backgroundColor: isDarkBlackPageTheme() ? Color.darkBlack : Color.white,
            // titleColor: isDarkBlackPageTheme() ? Color.light : Color.black,
            // backButtonType: BackButtonType.arrow,
            // backButtonVisible: Visibility.visible,
            // backButtonColor: isDarkBlackPageTheme() ? Color.light : Color.black,
            // statusBarStyle: isDarkBlackPageTheme()
            //     ? StatusBarStyleType.white
            //     : StatusBarStyleType.black,
        };
    },
    //蓝色主题 蓝底 白字 用于网络检测,设备检测
    ThemeBlue() {
        let themeName = 'ThemeBlue';
        // if (isDarkBlackPageTheme()) {
        //     return Object.assign(this.ThemeAddDevice(), { themeName });
        // }
        return {
            themeName,
            theme: ThemeType.common,
            titleColor: Color.white,
            // backgroundColor: getThemeColor(),
            backButtonType: BackButtonType.arrow,
            backButtonVisible: Visibility.visible,
            backButtonColor: Color.white,
            statusBarStyle: StatusBarStyleType.white,
        };
    },
    // 橘黄色主题 黄底 白字
    ThemeYellow() {
        let themeName = 'ThemeYellow';
        return {
            themeName,
            theme: ThemeType.common,
            titleColor: Color.white,
            backgroundColor: Color.yellow,
            backButtonType: BackButtonType.arrow,
            backButtonVisible: Visibility.visible,
            backButtonColor: Color.white,
            statusBarStyle: StatusBarStyleType.white,
        };
    },
    // 橘黄色主题 黄底 白字
    ThemeBoyKeepYellow() {
        let themeName = 'ThemeBoyKeepYellow';
        return {
            themeName,
            theme: ThemeType.common,
            titleColor: Color.white,
            backgroundColor: Color.boykeepYellow,
            backButtonType: BackButtonType.arrow,
            backButtonVisible: Visibility.visible,
            backButtonColor: Color.white,
            statusBarStyle: StatusBarStyleType.white,
        };
    },
    ThemeBlack35() {
        let themeName = 'ThemeBlack35';
        return {
            themeName,
            theme: ThemeType.common,
            titleColor: Color.white,
            backgroundColor: Color.black35,
            backButtonType: BackButtonType.arrow,
            backButtonVisible: Visibility.visible,
            backButtonColor: Color.white,
            statusBarStyle: StatusBarStyleType.white,
        };
    },
    ThemeDarkBlack() {
        let themeName = 'ThemeDarkBlack';
        return {
            themeName,
            theme: ThemeType.common,
            titleColor: Color.white,
            backgroundColor: Color.darkBlack,
            backButtonType: BackButtonType.arrow,
            backButtonVisible: Visibility.visible,
            backButtonColor: Color.white,
            statusBarStyle: StatusBarStyleType.white,
        };
    },
};

export default TitleBarTheme;
